import { render, staticRenderFns } from "./DataInputSelect.vue?vue&type=template&id=d611be90&scoped=true&"
import script from "./DataInputSelect.vue?vue&type=script&lang=js&"
export * from "./DataInputSelect.vue?vue&type=script&lang=js&"
import style0 from "./DataInputSelect.vue?vue&type=style&index=0&id=d611be90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d611be90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
